import * as _ from "lodash";
import * as moment from "moment";
import * as toastr from "toastr";

import * as UserManagement from "../";
import * as Common from "../../Common/modules";
import * as Models from "../../Models";
import * as Routes from "../../Routes";
import * as Services from "../../Services";
import * as Shared from "../../Shared";
import { getBaseUrl } from "../../Shared/React/store/baseUrlService";

export interface IUpdatePaymentMethodCustomerScope extends ng.IScope {
  updatePaymentMethodCustomerCtrl: UpdatePaymentMethodCustomerCtrl;
}

export class UpdatePaymentMethodCustomerCtrl {
  public abpAccountNumber: any;
  public userCanCollectPaymentInfo: boolean;
  public userInformation: Models.UserModel.IUserModel;
  public allGroups: Models.GroupModel.IGroupModel[];
  public allowPaymentPlanEnrollment: boolean;
  public paymentPlanUnratedProductionMessage: string = "";
  public enrollInPaymentPlanButtonTitle: string = "Enroll in Payment Plan";

  //Request Objects
  public updatePaymentInformationRequest: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationRequest;

  //Response Objects
  public customerDetails: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationCustomerDetailResponse;
  public updatePaymentInformationResult: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationResult;

  //Form Variables
  public formControlVariables =
    new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentMethodFormControlVariables();
  public collectionOptions: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectionOption[];
  public collectPayUpdateOnlySlider =
    new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectPayUpdateOnlySlider();
  public autoPayAuthSlider = new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.AutoPayAuthSlider();
  public selectedCollectionOption: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectionOption;
  public cardTypes = ["American Express", "Discover", "MasterCard", "Visa"];
  public months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  public expirationMonth: number;
  public expirationYear: number;
  public years: number[];
  public accountNumberVerify: number;
  public paymentType = "ELECTRONIC_CHECK";
  public updatePaymentMethodCompletionTime: Date;
  public callBlackoutActive: boolean;
  public currentBalance: string;
  public customerHasAutoPayAuth: boolean;
  public updatePaymentStep: number;
  public scriptsVerbiage: string;
  public autoPayAuth: string;

  public setupPaymentPlan: string;
  public paymentPlanAmount: string;
  public paymentPlanNumberOfPayments: string;
  public paymentPlanUpfrontPaymentAmount: string;
  public paymentPlanMonthlyPaymentAmount: string;

  public currentUser: any;
  public user: Models.UserModel.UserModel;

  public static $inject = [
    "$scope",
    "$state",
    "UserService",
    "UpdatePaymentMethodApiClient",
    "ngToast",
    "CallRecordingApiClient",
    "$rootScope",
    "$modal",
    "ScriptsApiClient",
    "CustomerApiClient",
    "$q",
  ];

  constructor(
    private $scope: IUpdatePaymentMethodCustomerScope,
    private $state: angular.ui.IStateService,
    private userService: Services.UserService.IUserService,
    private updatePaymentMethodApiClient: Services.UpdatePaymentMethodApiClient.IUpdatePaymentMethodApiClient,
    private ngToast: any,
    private callRecordingApiClient: Services.CallRecordingApiClient.ICallRecordingApiClient,
    private $rootScope: ng.IRootScopeService,
    private $modal: angular.ui.bootstrap.IModalService,
    private scriptsApiClient: Services.ScriptsApiClient.IScriptsApiClient,
    private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
    private $q: angular.IQService,
  ) {
    $scope.updatePaymentMethodCustomerCtrl = this;
    window.scrollTo(0, 0);

    this.setupPaymentPlan = sessionStorage.getItem("setupPaymentPlan");
    this.paymentPlanAmount = sessionStorage.getItem("paymentPlanAmount");
    this.paymentPlanNumberOfPayments = sessionStorage.getItem("numberOfPayments");
    this.paymentPlanUpfrontPaymentAmount = sessionStorage.getItem("upfrontPaymentAmount");
    this.paymentPlanMonthlyPaymentAmount = sessionStorage.getItem("monthlyPaymentAmount");

    $rootScope.$on("$stateChangeStart", ((
      event: angular.IAngularEvent,
      toState: angular.ui.IState,
      toParams: any,
      fromState: angular.ui.IState,
      fromParams: any,
    ) => {
      if (fromState.name === "main.updatePaymentMethodCustomer") {
        if (this.callBlackoutActive) {
          this.blackoutCallStop(false);
        }
      }
    }) as any);

    this.isGenesysAuthenticated();

    this.abpAccountNumber = this.$state.params["abpAccountNumber"];
    this.callBlackoutActive = false;

    this.setupUpdatePaymentInformation();
    this.updatePaymentStep = 1;
  }

  public isGenesysAuthenticated = (): void => {
    this.callRecordingApiClient.isAuthenticated().then((result: boolean) => {
      if (!result) {
        this.authenticate();
      }
    });
  };

  private authenticate = (): void => {
    var base = Shared.Constants.Reference.Reference.Genesys_BaseUrl;
    var redirect_uri = `${getBaseUrl()}genesysAuthRedir`;
    var org = Shared.Constants.Reference.Reference.Genesys_Org;
    var provider = Shared.Constants.Reference.Reference.Genesys_Provider;
    var clientId = Shared.Constants.Reference.Reference.Genesys_ClientId;
    var target = Shared.Constants.Reference.Reference.Genesys_Target;
    var state = btoa(window.location.href);

    var genesysAuthUrl = `${base}?client_id=${clientId}&response_type=code&redirect_uri=${redirect_uri}&org=${org}&provider=${provider}&target=${target}&state=${state}`;

    window.open(genesysAuthUrl, "_self");
  };

  public setupUpdatePaymentInformation = (): void => {
    var request =
      new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationCustomerDetailRequest();
    request.abpAccountNumber = this.abpAccountNumber;

    this.setAbilityToCollectPaymentInfo();

    this.updatePaymentMethodApiClient
      .getCustomerDetailsForUpdatePaymentMethod(request)
      .then(
        (
          response: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationCustomerDetailResponse,
        ) => {
          this.customerDetails = response;
          this.formControlVariables.customerPaymentInformationIsOnFile =
            response.achDisplay !== null || response.creditCardDisplay !== null;
          this.getPaymentOptionsForAccount(this.customerDetails);
          this.buildYears();
          this.setWatchOnPaymentTypeChanges(this.$scope);
          this.getCustomerEventsMap();
          if (response.customer.communicationType.code == "DNC") {
            toastr.error(
              "Customer is listed as Do Not Contact. Collecting Payment Info is not permitted",
              "DO NOT CONTACT CUSTOMER",
            );
            this.$state.go("main.customerv2", { igsCustomerNumber: this.customerDetails.customer.igsCustomerNumber });
          }
          this.setAllowPaymentPlanEnrollment();
          this.setupReturnFromPaymentPlanEnrollment();
        },
      );
  };

  private setAllowPaymentPlanEnrollment = (): void => {
    this.allowPaymentPlanEnrollment =
      !this.customerDetails.isOnPaymentPlan && this.customerDetails.isEligibleForPaymentPlan;

    if (this.allowPaymentPlanEnrollment) {
      this.paymentPlanUnratedProductionMessage = !this.customerDetails.hasUnratedProduction
        ? ""
        : "The customer is eligible for a payment plan, but they have unrated production. Please wait until the next billing cycle to set the customer up on a payment plan or work with the Collections team to rate and invoice production off-cycle.";
      if (this.paymentPlanUnratedProductionMessage !== "")
        this.enrollInPaymentPlanButtonTitle = this.paymentPlanUnratedProductionMessage;
    }
  };

  public enrollInPaymentPlan = (): void => {
    //route to new screen
    this.$state.go("main.createPaymentPlan", { abpAccountNumber: this.customerDetails.abpAccountNumber });
  };

  private setupReturnFromPaymentPlanEnrollment = (): void => {
    if (this.setupPaymentPlan !== "true") return;

    if (!this.updatePaymentInformationRequest) {
      this.updatePaymentInformationRequest =
        new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationRequest();
    }

    this.updatePaymentInformationRequest.abpAccountNumber = this.customerDetails.abpAccountNumber;
    this.updatePaymentInformationRequest.amountToCollect = parseFloat(this.paymentPlanUpfrontPaymentAmount);

    if (!this.updatePaymentInformationRequest.paymentPlanSetupRequest) {
      this.updatePaymentInformationRequest.paymentPlanSetupRequest =
        new Models.UpdatePaymentMethod.PaymentPlanSetupRequest.PaymentPlanSetupRequest();
    }

    var paymentPlanSetupRequest = this.updatePaymentInformationRequest.paymentPlanSetupRequest;

    paymentPlanSetupRequest.agreedMonthlyPaymentAmount = parseFloat(this.paymentPlanMonthlyPaymentAmount);
    paymentPlanSetupRequest.agreedNumberOfPayments = parseInt(this.paymentPlanNumberOfPayments);
    paymentPlanSetupRequest.balanceToForward = parseFloat(this.paymentPlanAmount);
    paymentPlanSetupRequest.agreedUpfrontPaymentAmount = this.updatePaymentInformationRequest.amountToCollect;

    sessionStorage.clear();

    this.blackoutCallStart(true).then((isBlackedOut: boolean) => {
      if (isBlackedOut) {
        this.updatePaymentStep = 2;
      }
    });
  };

  private getCustomerEventsMap = (): void => {
    if (this.customerDetails.customer.igsCustomerNumber) {
      this.customerApiClient
        .getCustomerEventsMap(this.customerDetails.customer.igsCustomerNumber)
        .then((result: Models.Customer.CustomerEventMap.CustomerEventMap) => {
          var customerEvents = result;
          this.customerHasAutoPayAuth =
            customerEvents &&
            customerEvents.autoPaymentAuthorization &&
            customerEvents.autoPaymentAuthorization.eventOutcomeCode ===
              Shared.Constants.Reference.Reference.successEventOutcomeCode;
        });
    }
  };

  public blackoutCallStart = (verifyRecording: boolean): ng.IPromise<any> => {
    if (this.customerDetails.shouldDisplaySilenceCallRecording && this.userCanCollectPaymentInfo) {
      var request = new Models.CallRecording.CallRecordingRequest.CallRecordingRequest();
      request.verifyRecording = verifyRecording;

      return this.callRecordingApiClient.blackoutCallStart(request).then(
        () => {
          this.callBlackoutActive = true;
          return this.callBlackoutActive;
        },
        (error: any) => {
          if (error.statusText === "Invalid user or user cannot be authenticated") {
            this.authenticate();
          }
          this.callBlackoutActive = false;
          var errorText = error.statusText;
          toastr.error("An error has occurred: " + errorText, "Unable to black out call recording");
          return this.callBlackoutActive;
        },
      );
    } else {
      var deferred = this.$q.defer();
      deferred.resolve(true);
      return deferred.promise;
    }
  };

  public blackoutCallStop = (verifyRecording: boolean): ng.IPromise<any> => {
    if (this.customerDetails.shouldDisplaySilenceCallRecording) {
      var request = new Models.CallRecording.CallRecordingRequest.CallRecordingRequest();
      request.verifyRecording = verifyRecording;

      return this.callRecordingApiClient.blackoutCallStop(request).then(
        () => {
          this.callBlackoutActive = false;
          return this.callBlackoutActive;
        },
        () => {
          this.callBlackoutActive = true;
          toastr.error("An error has occurred!", "Unable to disable call recording blackout");
          return this.callBlackoutActive;
        },
      );
    } else {
      var deferred = this.$q.defer();
      deferred.resolve(false);
      return deferred.promise;
    }
  };

  public submitPaymentCollectionDetails = (): void => {
    this.updatePaymentInformationRequest.abpAccountNumber = this.customerDetails.abpAccountNumber;
    this.updatePaymentInformationRequest.amountToCollect = 0;

    if (this.selectedCollectionOption && this.selectedCollectionOption.amount > 0) {
      this.updatePaymentInformationRequest.amountToCollect = this.selectedCollectionOption.amount;
    }

    if (
      this.updatePaymentInformationRequest.amountToCollect > 0 &&
      this.updatePaymentInformationRequest.amountToCollect > parseFloat(this.currentBalance)
    ) {
      var amountToCollect = parseFloat(this.updatePaymentInformationRequest.amountToCollect.toString()).toFixed(2);
      var modalInstance = this.$modal.open({
        template: require("./overpaymentConfirmationModal.html"),
        controller: Shared.Framework.ControllerHelpers.create(
          Routes.UpdatePaymentMethod.overpaymentConfirmationModal.OverpaymentConfirmationModalCtrl,
        ),
        resolve: {
          passedInCurrentBalance: () => {
            return this.currentBalance;
          },
          passedInAmountToCollect: () => {
            return amountToCollect;
          },
        },
      });

      modalInstance.result.then((result: boolean) => {
        if (result) {
          this.blackoutCallStart(true).then((isBlackedOut: boolean) => {
            if (isBlackedOut) {
              this.updatePaymentStep = 2;
            }
          });
        }
      });
    } else {
      this.blackoutCallStart(true).then((isBlackedOut: boolean) => {
        if (isBlackedOut) {
          this.updatePaymentStep = 2;
        }
      });
    }
  };

  private confirmPaymentAuthorization = (): void => {
    this.formControlVariables.submittingUpdatePaymentMethod = true;
    this.updatePaymentInformationRequest.autoPay = this.autoPayAuth === "YES";
    this.finishSubmittingPayment();
  };

  private finishSubmittingPayment = (): void => {
    if (this.updatePaymentInformationRequest.paymentInfo.creditCard) {
      this.formatCreditCardForSubmission();
    }

    this.updatePaymentInformationRequest.ldcAccountNumber = this.customerDetails.ldcAccountNumber;

    this.updatePaymentInformationRequest.useExisting = this.paymentType === "USE_EXISTING";

    this.updatePaymentMethodApiClient.submitUpdatePaymentInformation(this.updatePaymentInformationRequest).then(
      (result: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationResult) => {
        this.updatePaymentInformationResult = result;

        if (this.updatePaymentInformationResult.responseCode === 0) {
          this.formControlVariables.hasPaymentError = false;
          this.updatePaymentMethodCompletionTime = new Date();
          if (!this.updatePaymentInformationRequest.useExisting) {
            this.customerDetails.customer.fullName =
              this.updatePaymentInformationRequest.paymentInfo.creditCard?.nameOnCard ??
              this.updatePaymentInformationRequest.paymentInfo.ach.accountName;
          }
        } else if (this.updatePaymentInformationResult.responseCode === 3) {
          this.formControlVariables.hasPaymentPlanError = true;
        } else {
          this.formControlVariables.hasPaymentError = true;
        }

        this.formControlVariables.hasSubmittedUpdatePaymentMethod = true;
        this.formControlVariables.submittingUpdatePaymentMethod = false;
      },
      () => {
        this.formControlVariables.submittingUpdatePaymentMethod = false;
      },
    );
  };

  public editPaymentInformation = (): void => {
    this.blackoutCallStart(true).then((isBlackedOut: boolean) => {
      if (isBlackedOut) {
        this.formControlVariables =
          new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentMethodFormControlVariables();
        this.formControlVariables.editPaymentInformationOnly = true;
        this.updatePaymentStep = 2;
        this.updatePaymentInformationResult = null;
        this.clearPaymentInformation();
      }
    });
  };

  public startNewUpdatePaymentMethod = (): void => {
    this.$state.go("main.updatePaymentMethod");
  };

  public returnToHomePage = (): void => {
    this.$state.go("main.customersearchv2");
  };

  public getPaymentOptionsForAccount = (
    customerDetail: Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationCustomerDetailResponse,
  ): void => {
    this.collectionOptions = [];

    collectionOption = new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectionOption();
    collectionOption.text = `Current Balance: $${customerDetail.currentBalance.toFixed(2)}`;
    collectionOption.amount = customerDetail.currentBalance;
    this.currentBalance = customerDetail.currentBalance.toFixed(2);
    this.collectionOptions.push(collectionOption);

    var collectionOption = new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectionOption();
    collectionOption.text = `Invoice Amount: $${customerDetail.invoiceAmount.toFixed(2)}`;
    collectionOption.amount = customerDetail.invoiceAmount;
    this.collectionOptions.push(collectionOption);

    collectionOption = new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectionOption();
    collectionOption.text = `Past Due: $${customerDetail.pastDue.toFixed(2)}`;
    collectionOption.amount = customerDetail.pastDue;
    this.collectionOptions.push(collectionOption);

    collectionOption = new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.CollectionOption();
    collectionOption.text = "Other";
    collectionOption.amount = null;
    this.collectionOptions.push(collectionOption);
  };

  public toggleCollectPayUpdateOnlySlider = (): void => {
    if (!this.userCanCollectPaymentInfo || this.updatePaymentStep != 1) return;

    if (this.collectPayUpdateOnlySlider.enabled) {
      this.collectPayUpdateOnlySlider.enabled = false;
      this.selectedCollectionOption = null;
    } else {
      this.collectPayUpdateOnlySlider.enabled = true;
      this.selectedCollectionOption = null;
    }

    if (this.paymentType === "USE_EXISTING") {
      this.paymentType = "ELECTRONIC_CHECK";
    }
  };

  private expirationDateValid = (): boolean => {
    var year = this.expirationYear;
    var month = this.expirationMonth;

    return !Number(year) || !this.inPast(year, month);
  };

  private inPast = (year: number, month: number): boolean => {
    if (Number(month)) {
      var today = Number(`${moment().year()}${moment().format("MM")}`),
        exDate = Number(`${year}${month}`);
      return exDate < today;
    } else if (Number(year)) {
      return moment().year() > year;
    } else {
      return null;
    }
  };

  private buildYears = (): void => {
    this.years = [];
    for (var i = 0; i <= 10; i++) {
      this.years.push(moment().add(i, "years").year());
    }
  };

  public formatCreditCardForSubmission = (): void => {
    this.updatePaymentInformationRequest.paymentInfo.creditCard.expiration = new Date(
      this.expirationYear,
      this.expirationMonth - 1,
      1,
    );
    if (this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "Visa") {
      this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType = 1;
    }
    if (this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "MasterCard") {
      this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType = 2;
    }
    if (this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "Discover") {
      this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType = 3;
    }
    if (this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "American Express") {
      this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType = 4;
    }
  };

  private setWatchOnPaymentTypeChanges = ($scope: ng.IScope): void => {
    $scope.$watch("updatePaymentMethodCustomerCtrl.paymentType", () => {
      this.clearPaymentInformation();
    });
  };

  private clearPaymentInformation = (): void => {
    if (!this.updatePaymentInformationRequest) {
      this.updatePaymentInformationRequest =
        new Models.UpdatePaymentMethod.UpdatePaymentMethodSearchResult.UpdatePaymentInformationRequest();
    }

    if (!this.updatePaymentInformationRequest.paymentInfo) {
      this.updatePaymentInformationRequest.paymentInfo = new Models.PaymentCapture.PaymentInfo.PaymentProfile();
    }

    this.updatePaymentInformationRequest.paymentInfo.creditCard = null;
    this.updatePaymentInformationRequest.paymentInfo.ach = null;
    this.updatePaymentInformationRequest.paymentInfo.bypassPayment = false;
    this.expirationMonth = null;
    this.expirationYear = null;
    this.accountNumberVerify = null;
  };

  private securityCodeValid = (): boolean => {
    if (
      this.updatePaymentInformationRequest &&
      this.updatePaymentInformationRequest.paymentInfo &&
      this.updatePaymentInformationRequest.paymentInfo.creditCard
    ) {
      var code = this.updatePaymentInformationRequest.paymentInfo.creditCard.cardVerificationValue;

      return (
        ((this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "Visa" ||
          this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "Discover" ||
          this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "MasterCard") &&
          String(code).trim().length === 3) ||
        (this.updatePaymentInformationRequest.paymentInfo.creditCard.cardType === "American Express" &&
          String(code).trim().length === 4)
      );
    }
    return false;
  };

  private setAbilityToCollectPaymentInfo = () => {
    var roleList = new Models.Auth.RoleList.RoleList();
    this.userService.isUserInRole(roleList.collectPaymentInformation).then(
      (userCanCollectPaymentCapture: boolean) => {
        this.userCanCollectPaymentInfo = userCanCollectPaymentCapture;
        if (!userCanCollectPaymentCapture) this.paymentType = "USE_EXISTING";
      },
      () => {
        toastr.error("Error getting user permission.");
        this.$state.go("main.customerv2", {
          igsCustomerNumber: this.customerDetails.customer.igsCustomerNumber,
        });
      },
    );
  };

  public returnToCustomerProfile = (): void => {
    if (this.customerDetails.customer.igsCustomerNumber != null) {
        var custNum = this.customerDetails.customer.igsCustomerNumber;
        this.$state.go("main.customerv2", { igsCustomerNumber: custNum });
    } else {
        this.returnToHomePage();
    }
  };

  // boolean for ng-disabled - true means can't submit
  private performCustomFormValidation = (): boolean => {
    if (this.formControlVariables.submittingUpdatePaymentMethod) {
      return true;
    }

    if (this.paymentType === "USE_EXISTING" && this.selectedCollectionOption) {
      return this.selectedCollectionOption.amount <= 0 || !this.formControlVariables.customerPaymentInformationIsOnFile;
    }

    return false;
  };

  // boolean for ng-disabled - true means can't submit
  private validatePaymentAuthSelection = (): boolean => {
    if ((!this.customerHasAutoPayAuth || this.paymentType !== "USE_EXISTING") && !this.autoPayAuth) {
      return true;
    }

    return false;
  };

  // boolean for ng-disabled - true means can't submit
  private performCollectPaymentValidation = (): boolean => {
    if (!this.collectPayUpdateOnlySlider.enabled) {
      return true;
    } else if (this.selectedCollectionOption) {
      if (this.selectedCollectionOption.text === "Other" && this.selectedCollectionOption.amount > 0) {
        return true;
      } else {
        return this.selectedCollectionOption.text !== "Other";
      }
    } else {
      return false;
    }
  };

  private paymentInfoConfirmed = (): void => {
    if (!this.customerDetails.customer.igsCustomerNumber) {
      // NOTE: community customers do not currently support the auto payment authorization logic so we should just submit the update...
      this.blackoutCallStop(false);
      this.confirmPaymentAuthorization();
    } else {
      this.blackoutCallStop(true).then((isBlackedOut: boolean) => {
        if (!isBlackedOut) {
          this.updatePaymentStep = 3;
          var request = new Models.Scripts.ScriptsRequest.ScriptsRequest();
          request.igsCustomerNumber = this.customerDetails.customer.igsCustomerNumber;
          request.isAchPayment =
            this.paymentType === "ELECTRONIC_CHECK" ||
            (this.paymentType === "USE_EXISTING" &&
              this.customerDetails.achDisplay !== null &&
              this.collectPayUpdateOnlySlider.enabled);
          request.isCreditCardPayment =
            this.paymentType === "CREDIT_CARD" ||
            (this.paymentType === "USE_EXISTING" &&
              this.customerDetails.creditCardDisplay !== null &&
              this.collectPayUpdateOnlySlider.enabled);
          request.isAutoPayAuth = !this.customerHasAutoPayAuth || this.paymentType !== "USE_EXISTING";
          request.paymentAmount = this.updatePaymentInformationRequest.amountToCollect;
          request.lastFourDigits = this.getLastFourDigits(request);

          this.scriptsApiClient
            .getPaymentAuthScripts(request)
            .then((result: Models.Scripts.ScriptsResponse.ScriptsResponse) => {
              this.scriptsVerbiage = result.scriptVerbiage;
            });
        }
      });
    }
  };

  private getLastFourDigits = (request: Models.Scripts.ScriptsRequest.ScriptsRequest): string => {
    if (this.paymentType === "USE_EXISTING") {
      return request.isAchPayment
        ? this.customerDetails.achDisplay.lastFourAccount
        : this.customerDetails.creditCardDisplay.lastFour;
    } else {
      return request.isCreditCardPayment
        ? this.updatePaymentInformationRequest.paymentInfo.creditCard.cardNumber.toString().slice(-4)
        : this.updatePaymentInformationRequest.paymentInfo.ach.accountNumber.toString().slice(-4);
    }
  };
}
